// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ExtendedAddress$PorterinFeature from "../ExtendedAddress.mjs";
import * as GeoLocationHelper$PorterinFeature from "../../../../order-review/domain/helpers/GeoLocationHelper.mjs";

function initialFormState(query_params) {
  return {
          pickup_address: ExtendedAddress$PorterinFeature.initial_address(undefined),
          drop_address: ExtendedAddress$PorterinFeature.initial_address(undefined)
        };
}

function checkIsCoordsUnderPolygon(order_context, lat, lng, waypoint) {
  var data = order_context.location_bound;
  if (data !== undefined) {
    return GeoLocationHelper$PorterinFeature.isCoordsUnderPolygon(waypoint === /* Pickup */0 ? data.pickup_polygon : data.drop_polygon, {
                lat: lat,
                lng: lng
              });
  } else {
    return false;
  }
}

function onFormSubmit(order_context, address_context, waypoint, output, toggleModal) {
  if (waypoint) {
    if (!checkIsCoordsUnderPolygon(order_context, output.drop_address.location.lat, output.drop_address.location.lng, /* Dropoff */1)) {
      return Curry._1(toggleModal, {
                  TAG: /* ErrorModal */0,
                  _0: true,
                  _1: /* InvalidDrop */2,
                  _2: /* OrderReview */3
                });
    }
    Curry._1(order_context.set_vehicles_result, undefined);
    var init = address_context.receiver;
    return Curry._1(address_context.set_receiver, {
                pickup_address: init.pickup_address,
                drop_address: {
                  landmark: output.drop_address.landmark,
                  location: {
                    lat: output.drop_address.location.lat,
                    lng: output.drop_address.location.lng
                  },
                  extended_address: {
                    state: output.drop_address.extended_address.state,
                    city: output.drop_address.extended_address.city,
                    pincode: output.drop_address.extended_address.pincode,
                    locality: output.drop_address.extended_address.locality,
                    sub_locality: output.drop_address.extended_address.sub_locality
                  }
                },
                name: init.name,
                number: init.number,
                house: init.house
              });
  }
  if (!checkIsCoordsUnderPolygon(order_context, output.pickup_address.location.lat, output.pickup_address.location.lng, /* Pickup */0)) {
    return Curry._1(toggleModal, {
                TAG: /* ErrorModal */0,
                _0: true,
                _1: /* InvalidPickup */1,
                _2: /* OrderReview */3
              });
  }
  Curry._1(order_context.set_vehicles_result, undefined);
  var init$1 = address_context.sender;
  Curry._1(address_context.set_sender, {
        pickup_address: {
          landmark: output.pickup_address.landmark,
          location: {
            lat: output.pickup_address.location.lat,
            lng: output.pickup_address.location.lng
          },
          extended_address: {
            state: output.pickup_address.extended_address.state,
            city: output.pickup_address.extended_address.city,
            pincode: output.pickup_address.extended_address.pincode,
            locality: output.pickup_address.extended_address.locality,
            sub_locality: output.pickup_address.extended_address.sub_locality
          }
        },
        drop_address: init$1.drop_address,
        name: init$1.name,
        number: init$1.number,
        house: init$1.house
      });
}

export {
  initialFormState ,
  checkIsCoordsUnderPolygon ,
  onFormSubmit ,
}
/* No side effect */
